import './Terms.css';

const Terms = ()=>{
    return(
        <div className = "body">
<h1>Terms and Conditions</h1>
  <p class="last-updated">Last Updated: August 22nd, 2026 PST</p>

  <div class="special-words">
    <strong>Special Words:</strong>
    <ul>
      <li><strong>Healers:</strong> Users who register on the website to promote their services in the Therapy field, such as Reiki, Energy Balance, and similar practices.</li>
    </ul>
  </div>

  <h2>1. Introduction</h2>
  <p>
    Welcome to the website <strong>WooWooNetwork</strong>. These Terms and Conditions govern your access to and use of our website located at &nbsp;
    <a href="https://woo-woo.net/" target="_blank" rel="noopener noreferrer">https://woo-woo.net/</a> and the services we provide for customers and healers.
  </p>
  <p>
    By accessing or using the Site or Services, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use the Site or Services.
  </p>

  <h2>2. Eligibility</h2>
  <p>
    You must be at least 18 years old, or the age of legal majority in your jurisdiction, to use our Services, as well as having valid IDs. By using the Services, you represent and warrant that you meet this requirement.
  </p>

  <h2>3. Description of Services</h2>
  <p>
    WooWooNetwork provides the means to connect healers to their potential customers. We reserve the right to modify, suspend, or discontinue any part of the Services at any time without prior notice.
  </p>

  <h2>4. Account Registration</h2>
  <p>To access certain features of the Site or Services, you may be required to create an account. You agree to:</p>
  <ul>
    <li>Provide accurate, current, and complete information during registration</li>
    <li>Maintain and promptly update your account information</li>
    <li>Keep your login credentials confidential</li>
    <li>Notify us immediately of any unauthorized use of your account</li>
    <li>Accept responsibility for all activities that occur under your account</li>
  </ul>

  <h2>5. Fees and Payment</h2>
  <ul>
    <li>Healers are required to pay a service fee, as described at the time of purchase, which is usually 12% of the total income of the healer's services.</li>
    <li>All fees are quoted in CAD and are exclusive of applicable taxes unless stated otherwise.</li>
    <li>Payment is due at the time specified during checkout or invoicing.</li>
    <li>We reserve the right to change our fees at any time, with reasonable notice provided for existing customers.</li>
    <li>Failure to pay fees when due may result in suspension or termination of Services.</li>
  </ul>

  <h2>6. Refund Policy</h2>
  <p>
    As of now, refunds can be issued on the healer's side and will not require any extra fee.
  </p>

  <h2>7. User Conduct</h2>
  <p>You agree not to:</p>
  <ul>
    <li>Use the Site or Services for any unlawful purpose or in violation of these Terms</li>
    <li>Attempt to gain unauthorized access to any portion of the Site or its related systems</li>
    <li>Interfere with or disrupt the integrity or performance of the Site or Services</li>
    <li>Upload or transmit viruses, malware, or other harmful code</li>
    <li>Harass, abuse, or harm another person through your use of the Services</li>
    <li>Misrepresent your identity or affiliation with any person or entity</li>
  </ul>
  <p>We reserve the right to suspend or terminate access for any user who violates these provisions.</p>

  <h2>8. Intellectual Property</h2>
  <p>
    All content on the Site, including text, graphics, logos, images, software, and design elements, is the property of Being Love Inc or its licensors and is protected by applicable intellectual property laws. You may not reproduce, distribute, modify, or create derivative works from any content without our prior written consent.
  </p>

  <h2>9. Third-Party Links and Services</h2>
  <p>
    The Site may contain links to third-party websites or services that are not owned or controlled by Being Love Inc. We are not responsible for the content, privacy policies, or practices of any third-party sites. Your use of such third-party sites is at your own risk.
  </p>

  <h2>10. Disclaimer of Warranties</h2>
  <p>
    The Site and Services are provided on an "as is" and "as available" basis without warranties of any kind, whether express or implied, including but not limited to implied warranties of merchantability, fitness for a particular purpose, and non-infringement. We do not guarantee that the Services will be uninterrupted, error-free, or secure.
  </p>

  <h2>11. Limitation of Liability</h2>
  <p>
    To the fullest extent permitted by law, Being Love Inc and its officers, directors, employees, and agents shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the Site or Services, even if advised of the possibility of such damages. Our total liability for any claim arising from these Terms shall not exceed the amount you paid us, if any, in the twelve (12) months preceding the claim.
  </p>

  <h2>12. Indemnification</h2>
  <p>
    You agree to indemnify, defend, and hold harmless Being Love Inc and its affiliates from any claims, damages, liabilities, losses, and expenses (including reasonable attorneys' fees) arising out of or related to your use of the Site or Services, your violation of these Terms, or your violation of any rights of a third party.
  </p>

  <h2>13. Termination</h2>
  <p>
    We reserve the right to suspend or terminate your access to the Site or Services at our sole discretion, without notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties, or for any other reason.
  </p>

  <h2>14. Privacy</h2>
  <p>
    Your use of the Site and Services is also governed by our <span class="placeholder">[Privacy Policy]</span>, which describes how we collect, use, and protect your personal information. By using the Site, you consent to the practices described in our Privacy Policy.
  </p>

  <h2>15. Governing Law and Dispute Resolution</h2>
  <p>
    These Terms shall be governed by and construed in accordance with the laws of British Columbia, Canada, without regard to its conflict of law provisions. Any disputes arising under these Terms shall be resolved in the courts located in <span class="placeholder">[Jurisdiction]</span>, or through <span class="placeholder">[arbitration/mediation, if applicable]</span>.
  </p>

  <h2>16. Changes to These Terms</h2>
  <p>
    We reserve the right to update or modify these Terms at any time. Any changes will be effective upon posting the revised Terms on the Site, with an updated "Last Updated" date. Your continued use of the Site or Services after changes are posted constitutes your acceptance of the revised Terms.
  </p>

  <h2>17. Severability</h2>
  <p>
    If any provision of these Terms is found to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain in full force and effect.
  </p>

  <h2>18. Entire Agreement</h2>
  <p>
    These Terms, together with our Privacy Policy and any other legal notices published on the Site, constitute the entire agreement between you and Being Love Inc regarding your use of the Site and Services.
  </p>

  <h2>19. Contact Information</h2>
  <p>If you have any questions about these Terms, please contact us at:</p>
  <div class="contact-block">
    <strong>Being Love Inc</strong><br/>
    Email: <a href="mailto:eelrebmik@gmail.com">eelrebmik@gmail.com</a><br/>
    Phone: 778 708-8369
  </div>

        </div>
    )
}
export default Terms;